import { render, staticRenderFns } from "./PaymentUpgrade.vue?vue&type=template&id=fb94328e&scoped=true&"
import script from "./PaymentUpgrade.vue?vue&type=script&lang=js&"
export * from "./PaymentUpgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb94328e",
  null
  
)

export default component.exports